<template>
  <div class="panel-body">
    <form class="form-horizontal" v-on:submit="save($event)">

      <h4>Change password</h4>

      <div class="row" style="margin-top: 25px">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label class="col-sm-4 control-label required">Old Password
            </label>
            <div class="col-sm-8">
              <input type="password" class="form-control" v-model="oldPassword" required>
              <label v-if="errorOldPassword" class="error">{{ errorOldPassword }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label class="col-sm-4 control-label required">New Password
            </label>
            <div class="col-sm-8">
              <input type="password" class="form-control" v-model="newPassword" required>
              <label v-if="errorNewPassword" class="error">{{ errorNewPassword }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 15px">
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label class="col-sm-4 control-label required">Confirm Password
            </label>
            <div class="col-sm-8">
              <input type="password" class="form-control" v-model="newPasswordConfirm" required>
              <label v-if="errorNewPasswordConfirm" class="error">{{ errorNewPasswordConfirm }}</label>
            </div>
          </div>
        </div>
      </div>

      <div class="row" style="margin-top: 25px">
        <div class="col-xs-12 text-center">
          <vue-ladda type="submit" :loading="submit.loading" class="btn btn-info" :data-style="submit.dataStyle">Save Changes</vue-ladda>
        </div>
      </div>

    </form>
  </div>
</template>

<script>

import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  name: 'UpdatePassword',
  props: ['userId'],
  data () {
    return {
      oldPassword: null,
      newPassword: null,
      newPasswordConfirm: null,
      errorOldPassword: null,
      errorNewPassword: null,
      errorNewPasswordConfirm: null,
      submit: {
        loading: false,
        'dataStyle': 'zoom-in'
      }
    }
  },
  methods: {
    save: function (e) {
      e.preventDefault()

      this.submit.loading = true

      this.errorOldPassword = null
      this.errorNewPassword = null
      this.errorNewPasswordConfirm = null

      this.axios.patch('user/password', {
        old_password: this.oldPassword,
        new_password: this.newPassword,
        new_password_confirmation: this.newPasswordConfirm
      }).then((response) => {
        this.oldPassword = null
        this.newPassword = null
        this.newPasswordConfirm = null
        this.$auth.fetch()
        this.$notify({
          type: 'success',
          title: 'Password Updated',
          placement: 'bottom-right'
        })

        setTimeout(function () {
          $('.nav-tabs a[href="#personal-info-tab"]').tab('show')
        }, 3000)

      }).catch((error) => {
        this.$notify({
          type: 'danger',
          title: 'something is wrong',
          placement: 'bottom-right'
        })

        let errors = error.response.data.errors

        switch (error.response.data.code) {
          case 1:
            this.errorOldPassword = errors['old_password'][0]
            break
          case 2:
            this.errorNewPassword = errors['new_password'][0]
            break
          case 3:
            this.errorNewPasswordConfirm = errors['new_password_confirmation'][0]
            break
          case 4:
            this.errorOldPassword = 'Password doesn\'t match'
            break
        }

      }).finally(() => {
        this.submit.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/UpdatePassword.vue